import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Select, Modal, } from 'antd';
import { siteConfig } from "../../settings";
import iconBuilding from '../../image/icon_building.png';
import TopbarCommunityWrapper from "./tobarCommunity.style";
import CommunitySwitcher from '../Page/Community/CommunitySwitcher';

const DEBUG = siteConfig.DEBUG
const { Option } = Select;

export default function TopbarCommunity() {
  const [communityID, setCommunityID] = useState(localStorage.getItem('communityID') || '');
  const [communityName, setCommunityName] = useState(localStorage.getItem('communityName') || '');
  const [communityList, setCommunityList] = useState(JSON.parse(localStorage.getItem('communityList')|| []));
  const [visibleSelectCommunity, setVisibleSelectCommunity] = useState(false);

  const handleChange = (value) => {
    DEBUG && console.log(`selected ${value}`);
  }

  return (
    <TopbarCommunityWrapper>
      <div>
        <div style={{ alignSelf: 'auto' }} onClick={()=>setVisibleSelectCommunity(true)}>

          <img src={iconBuilding} width='24' />
          {"  "}
          <span className="communityName">{communityName}</span>
          {/* {JSON.stringify(communityList)} */}
          {/* communityList: {communityList.length} */}
          {/* {communityList.length > 0 ? 
          <Select
            defaultValue={communityID || null}
            showArrow={true}
            onChange={handleChange}>
            {communityList.map(i => (
              <Option key={i.communityID} value={i.communityID}>
                <span className="communityName">{i.communityName}</span>
              </Option>
            ))}
          </Select>
          :''
        } */}
        </div>

         {/* SWITCH COMMUNITY MODAL */}
         <Modal
            title={<span style={{fontFamily:'Kanit', fontSize:20}}>เปลี่ยนชุมชน</span>}
            visible={visibleSelectCommunity}
            onOk={e => setVisibleSelectCommunity(false)}
            onCancel={e => setVisibleSelectCommunity(false)}
            footer={null}
            destroyOnClose={true}
          >
            <CommunitySwitcher />
          </Modal>
      </div>
    </TopbarCommunityWrapper>
  );

}